// FLYTOUR
//const API = "https://api2.flytour.com.br";
//const APIAEREO = "https://api2.flytour.com.br";
//const APIHOTEL = "https://api2.flytour.com.br";
const API = "https://apiflytour.geniusws.com.br";
const APIAEREO = "https://apiflytour.geniusws.com.br";
const APIHOTEL = "https://apiflytour.geniusws.com.br";

export const environment = {
    production: true,
    API: API,
    PAYPAL_CLIENT_ID: "",
    ambiente: "FLYTOUR",
    THEME: "", //(FRT - ARKBEDS - FRT-BLACK)
    //Módulos de turismo
    USA_CASAMENTO: true,
    USA_CONTRATO: true,
    USA_CIRCUITO: true,
    USA_TURISMO: true,
    USA_PACOTE: true,
    USA_SEGURO: true,
    USA_DISNEY: false,
    USA_CARRO: true,
    USA_AEREO: true,
    USA_LOJA: false,
    USA_CASA: false,
    USA_HOTEL: true,
    USA_BETO: true,
    USA_MARKUPIMPRESSAO: false,
    USA_PROMOCIONAL: false,
    USA_CADASTROAGENCIA: false,
    USA_ARKBEDS: false,
    USA_TERMOMETRO: true,
    USA_SOLICITARDESCONTO: true,
    USA_CADASTRO_CIRCUITO: false,
    USA_CADASTRO_APARTAMENTO_EXCLUSIVO: true,
    USA_TRADUTOR: true,
    USA_EVENTOS: false,
    USA_RODOVIARIO: false,
    ASSISTCARDLATAM: false,
    //Apis dos módulos de turismo
    TURISMO_AEREO: APIAEREO,
    TURISMO_HOTEL: APIHOTEL,
    TURISMO_SERVICO: API,
    TURISMO_SEGURO: API,
    TURISMO_CARRO: API,
    TURISMO: API,
    GERENCIAMENTO: API,
    EMPRESAS: API,
    VALIDAPRAZOCANCELAMENTOMANUTENCAO: false,

    //Módulos Adicionais
    USA_BLOQUEIO_FRT: false, // Permite o uso de um botão adicional na aba bloqueios
    USA_INTRANET: true, // Permite o uso da Intranet no portal
    USA_LAMINAS: true, // Permite Gerar Lâminas no portal
    USA_BANNERS: true, //Permite o uso de Banners
    USA_ESIM: false,
    USA_BLOQUEIO_VOUCHER_CONTRATO: true,

    //Configurações
    USA_PACOTESIMPLIFICADO: false,
    CLIENT_ID: "postman:123",
    MAPBOX_ACCESSTOKEN:
        "pk.eyJ1IjoiZnJ0b3BlcmFkb3JhIiwiYSI6ImNsN3E5a3N0YTAycm00MW8wd2J5NXFoMjIifQ.NDfY7OK_ygHR567e-TVVcw",
    ITENSPORPAGINA: 20,
    MAXIMO_QUARTOS: 4,
    TAG_GOOGLE: "",
    URLSITE: "",
};
